import React from "react";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import { selectCompany } from "../../store/context/selectors";
import { connect } from "react-redux";
import Services from "../../services/Services";
import ICompany from "../../models/ICompany";
import { IMenuItem } from "../../models/IMenuItem";
import FormSelect from "../forms/FormSelect";
import { IFormError } from "../forms/FormErrors";
import IntegrationAddButton from "./IntegrationAddButton";
import { NewIntegrationDialog } from "./dialogs/new/NewIntegrationDialog";
import { addPending, completePending } from "../../store/status/actions";

export interface IIntegrationSelectProps {
  token: string;
  company?: ICompany;
  onValueChange: (val: IMenuItem | null) => void;
  required?: boolean;
  error?: IFormError;
  className?: string;
}

function IntegrationSelect(props: IIntegrationSelectProps): JSX.Element {
  const { token, company, onValueChange, required, error, className } = props;
  const [items, setItems] = React.useState<IMenuItem[]>([]);
  const [showAddIntegration, setShowAddIntegration] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  async function fetchIntegrations() {
    if (!isLoading) {
      return;
    }
    if (company) {
      const repo = await new Services().IntegrationRepository();
      const integrations = await repo.getByCompany(token, company.ID);
      const options = integrations
        .map(i => {
          return {
            ID: i.ID,
            Name: `${i.Name} (${i.System.Name})`,
          } as IMenuItem;
        })
        .sort((a, b) => a.Name.localeCompare(b.Name));
      setItems(options);
    }
    setIsLoading(false);
  }

  React.useEffect(() => {
    fetchIntegrations();
  }, [isLoading]);

  return (
    <>
      <NewIntegrationDialog
        showDialog={showAddIntegration}
        onClose={() => setShowAddIntegration(false)}
        company={company}
        token={token}
        addPending={addPending}
        completePending={completePending}
      />
      <FormSelect<IMenuItem>
        name="Integration.ID"
        label="Integration"
        prompt={isLoading ? "Loading Integrations..." : "Select Integration"}
        options={items}
        onValueChange={onValueChange}
        required={required}
        disabled={isLoading}
        error={error}
        className={className}
      />
      <IntegrationAddButton onClick={() => setShowAddIntegration(true)} />
    </>
  );
}

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
  company: selectCompany(state),
}))(IntegrationSelect);
